import { render } from "./TopMenuBar.vue?vue&type=template&id=26c7e7bc"
import script from "./TopMenuBar.vue?vue&type=script&lang=js"
export * from "./TopMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__